import { get, withUrl, Request } from '../rest';


const registrationPart = withUrl('registration');

export const registration = {
    confirm: get<Request.Query, void>(
        ({ query }) => registrationPart({
            path: 'confirm',
            query,
        }),
    ),
};
